import React, { useState } from 'react';
import { Styles } from '../../../../config/design/styles';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { translate } from '../../../../config/lang';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import { CloudUploadRounded } from '@mui/icons-material';
import {useSnackbar} from "notistack";
import {CircularProgress, Hidden, IconButton} from "@mui/material";
import {useTranslation} from "react-i18next";

const AddFile = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const { classes, type } = props;
    const [loading, setLoading] = useState(false);
    const [percentCompleted, setPercentCompleted] = useState(0);
    const [uploadText, setUploadText] = useState(t('uploadImage'));
    const [disable, setDisable] = useState(false);
    const [file, setFile] = useState(null);

    const handleUploadSuccess = () => {
        setUploadText(t('uploadDone'));
        props.ChangeLoader();
        setTimeout(() => {
            setPercentCompleted(0);
            setUploadText(t('uploadImage'));
            setDisable(false);
        }, 3000);
    };

    const onUploadImage = (event) => {
        event.preventDefault();
        setLoading(true);
        setDisable(true);
        let canUpload = true;
        const length = event.target.files.length;

        for (let i = 0; i < length; i++) {
            const file = event.target.files[i];
            let fileSize = file.size / 1024;
            let name = file.name;
            let lastDot = name.lastIndexOf('.');
            let extension = name.substring(lastDot + 1);

            if (['png', 'jpg', 'jpeg', 'webp'].includes(extension) && fileSize > 10240) {
                enqueueSnackbar(t('fileSize10mb'), { variant: 'error' });
                setLoading(false);
                setDisable(false);
                canUpload = false;
            } else if (['xlsx', 'xls', 'doc', 'docs', 'pdf'].includes(extension) && fileSize > 20480) {
                enqueueSnackbar(t('fileSize20MB'), { variant: 'error' });
                setLoading(false);
                setDisable(false);
                canUpload = false;
            } else if (['mp4', 'mkv', 'avi', 'mov'].includes(extension) && fileSize > 2048000) {
                enqueueSnackbar(t('fileSize2GB'), { variant: 'error' });
                setLoading(false);
                setDisable(false);
                canUpload = false;
            }

            if (canUpload) {
                const data = new FormData();
                data.append('image', file);
                data.append('is_preview', !!props.preview ? 1 : 0);

                if (props.defined_width && props.defined_height) {
                    data.append('defined_width', props.defined_width);
                    data.append('defined_height', props.defined_height);
                }

                const loginToken = localStorage.getItem('ACT');
                const config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`,
                    },
                    onUploadProgress: (progressEvent) => {
                        setUploadText(t('uploading'));
                        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setPercentCompleted(percent);

                        if (percent === 100) {
                            handleUploadSuccess();
                        }
                    },
                };

                axios
                    .post(`${defaultVariables.url}/file/add`, data, config)
                    .then((response) => {
                        props.upload(response.data);
                    })
                    .catch((error) => {
                        if (error.response?.status === 403) {
                            enqueueSnackbar(t('storageIsFull'), { variant: 'warning' });
                        } else {
                            console.log(error.response);
                           enqueueSnackbar(t('submitErrorFile'), { variant: 'error' });
                        }
                        props.ChangeLoader();
                    });
            }
        }
        setLoading(false);
    };

    return (
        <React.Fragment>
            <div className={classes.uploadProgress}>
                <input
                    className={classes.FileManagerInput}
                    id="FileManager_Input"
                    type="file"
                    name="image"
                    multiple={!props.single}
                    accept={type === 'video' ? 'video/*' : type === 'image' ? 'image/*' : ''}
                    onChange={onUploadImage}
                    disabled={disable}
                />
                <label htmlFor="FileManager_Input">
                    <Hidden mdDown>
                        <Button
                            variant="outlined"
                            color="primary"
                            component="span"

                            startIcon={
                                percentCompleted ? (
                                    <CircularProgress  size={25} thickness={4} variant="static" value={percentCompleted} />
                                ) : (
                                    <CloudUploadRounded />
                                )
                            }
                        >
                            {uploadText}
                        </Button>
                    </Hidden>
                    <Hidden mdUp>
                        <IconButton
                            variant="outlined"
                            color="primary"
                            component="span"
                        >
                            {percentCompleted ? (
                                <CircularProgress  size={25} thickness={4} variant="static" value={percentCompleted} />
                            ) : (
                                <CloudUploadRounded />
                            )}
                        </IconButton>
                    </Hidden>
                </label>
            </div>
        </React.Fragment>
    );
};

export default withStyles(Styles)(AddFile);
